import { createFileRoute } from '@tanstack/react-router'
import AdministrationHome from 'Administration/containers/AdministrationHomeContainer'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard, adminClaims } from '../-guard'

export const Route = createFileRoute('/administration/')({
    component: () => (
        <Guard claims={adminClaims}>
            <Suspense fallback={<PageSkeleton variant="section" wrapper="page" />}>
                <AdministrationHome />
            </Suspense>
        </Guard>
    ),
})
